/**
 * Failed chunk and stylesheet loads are phrased differently by Vite and by each browser,
 * and every message carries the asset URL with its content hash.
 *
 * Grouping them by the URL splits one problem into a new issue per asset per deploy.
 */
const ASSET_LOADING_ERRORS: Array<{ pattern: RegExp; key: string }> = [
  { pattern: /Unable to preload CSS/i, key: 'preload-css' },
  { pattern: /Failed to fetch dynamically imported module/i, key: 'dynamic-import' },
  { pattern: /Importing a module script failed/i, key: 'dynamic-import' },
  { pattern: /error loading dynamically imported module/i, key: 'dynamic-import' },
]

export const getAssetLoadingFingerprint = (message: string): string[] | null => {
  const assetError = ASSET_LOADING_ERRORS.find(({ pattern }) => pattern.test(message))
  if (!assetError) {
    return null
  }

  return ['asset-loading', assetError.key]
}
